// extracted by mini-css-extract-plugin
export default {"form-auth-google-button":"GoogleAuth_form-auth-google-button__9mhEA"};